import { createContext, ReactNode, useContext } from 'react';

export type StatusService = {
  setUnreadMessages: (value: number) => void;
};

type Props = {
  children: ReactNode;
  statusService: StatusService;
};

const StatusServiceBridge = createContext({} as StatusService);

export const useStatusServiceBridge = () => useContext(StatusServiceBridge);

export const StatusServiceBridgeProvider = ({ children, statusService }: Props) => (
  <StatusServiceBridge.Provider value={statusService}>{children}</StatusServiceBridge.Provider>
);
